require('numbro')
require('moment')
require('pikaday')
require('zeroclipboard')
window.Handsontable = require('handsontable')

var Papa = require('papaparse/papaparse.js')

var hot

document.title = 'Sales Receipts - Finch'

var mapQbList = function (list, field) {
  var map
  list.map(function (item) {
    map[item[field]] = item.Id
  })
  return map
}

var mapQbList = function (list, field) {
  try {
    return list.map(function (item) {
      return item[field]
    })
  } catch (_err) {
  }
  return []
}

var customerNames
var totalAmount = 0

var setupTable = function () {
  if (hot) hot.destroy()
  document.getElementById('table-spinner').style.display = ''
  document.getElementById('amount-submit').style.display = 'none'

  $.get('/api/sales-receipts/options/' + $('#company').val(), function (qbOptions) {
    document.getElementById('table-spinner').style.display = 'none'
    document.getElementById('amount-submit').style.display = 'block'
    customerNames = mapQbList(qbOptions.customers, 'DisplayName')
    var depositAccounts = mapQbList(qbOptions.depositAccounts, 'Name')
    var paymentMethods = mapQbList(qbOptions.paymentMethods, 'Name')
    var items = mapQbList(qbOptions.items, 'FullyQualifiedName')
    var qbClasses = mapQbList(qbOptions.classes, 'FullyQualifiedName')

    hot = new Handsontable(document.getElementById('sales-receipts-table'), {
      data: [],
      stretchH: 'all',
      minSpareRows: 1,
      contextMenu: true,
      afterValidate: function (isValid, value, row, prop, source) {
        if (row === hot.countRows() - hot.getSettings().minSpareRows) {
          return true
        }
        return isValid
      },
      autoWrapRow: true,
      autoWrapCol: true,
      disableVisualSelection: false,
      manualColumnResize: true,
      manualRowResize: true,
      comments: true,
      rowHeaders: true,
      colHeaders: [
        'Date',
        'Donor',
        'Reference No',
        'Amount',
        'Payment Method',
        'Deposit To',
        'Product',
        'Description',
        'Class'
      ],
      columns: [
        {
          data: 'date',
          type: 'date',
          dateFormat: 'MM/DD/YYYY',
          correctFormat: true,
          allowEmpty: false
        },
        {
          data: 'customer',
          type: 'autocomplete',
          source: customerNames,
          strict: true,
          allowEmpty: false,
          width: '220px',
          filter: true
        },
        {
          data: 'referenceNumber',
          type: undefined
        },
        {
          data: 'amount',
          type: 'numeric',
          format: '$0,0.00'
        },
        {
          data: 'paymentMethod',
          type: 'autocomplete',
          source: paymentMethods,
          strict: false,
          allowEmpty: true
        },
        {
          data: 'depositAccount',
          type: 'autocomplete',
          source: depositAccounts,
          strict: false,
          allowEmpty: false
        },
        {
          data: 'item',
          type: 'autocomplete',
          source: items,
          strict: false,
          allowEmpty: false,
          width: '120px'
        },
        {
          data: 'memo',
          type: undefined
        },
        {
          data: 'class',
          type: 'autocomplete',
          source: qbClasses,
          strict: false,
          allowEmpty: true,
          width: '120px'
        },
      ],
      /* Hooks */
      afterChange: function (changes, source) {
        if (source === 'loadData') {
          return;
        }
        if (changes != null) {
          let change = changes[0]
          let rowNumber = change[0]
          let prop = change[1]
          let oldValue = change[2]
          let newValue = change[3]

          if (newValue === '')
            return

          if (hotHookCallbacks.afterChange[prop]) {
            let hookInfo = hotHookCallbacks.afterChange[prop]
            let restrictions = hookInfo.restrictions
            let restrictionFlag = false
            
            if (restrictions) {
              for (let i = 0; i < restrictions.length; i++) {
                let rstFunction = restrictions[i]
                if (rstFunction(rowNumber, prop, oldValue, newValue)) {
                  restrictionFlag = true
                  i = restrictions.length
                }
              }
            }

            if (!restrictionFlag) {
              hookInfo.function(change[0], change[1], change[2], change[3])
            }
          }
        }
      }
    })
  })
}
window.addEventListener('company-selected', setupTable)

var submitData = function () {
  $.post({
    url: '/api/sales-receipts',
    data: JSON.stringify({
      realmId: $('#company').val(),
      salesReceipts: hot.getSourceData()
    }),
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
  }, function (data) {
    document.getElementById('button-spinner').style.display = 'none'
    document.getElementById('sales-receipts-submit').style.display = ''
    
    hot.updateSettings({
      readOnly: false,
      contextMenu: true,
      disableVisualSelection: false,
      manualColumnResize: true,
      manualRowResize: true,
      comments: true
    })

    var adjustRow = 0
    var failed = 0
    for (var i = 0; i < data.rows.length; i++) {
      if (data.rows[i].remove) {
        hot.alter('remove_row', i - adjustRow)
        adjustRow++
      } else {
        failed++
      }
    }

    caculateTotalAmount ()

    $('#successful-submission-count').html(adjustRow)
    if (failed) {
      $('#unsuccessful-submission-alert').show()
      $('#unsuccessful-submission-count').html(failed)
    } else {
      $('#unsuccessful-submission-alert').hide()
    }
    $('#successful-submission-modal').modal('show')
  })
}

var caculateTotalAmount = function () {
  totalAmount = 0.0
  var data = hot.getSourceData()
  for (var i = 0; i < data.length; i++) {
    if (!data[i].amount) continue
    totalAmount += data[i].amount * 1.0
  }
  $('#sales-receipts-sum').html(totalAmount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
}

$('#new-customer-cancel').click(function () {
  $('#new-customer-modal').modal('hide')
})

$('#sales-receipts-submit').click(function () {
  hot.validateCells(function (valid) {
    if (valid) {
      document.getElementById('sales-receipts-submit').style.display = 'none'
      document.getElementById('button-spinner').style.display = 'inline'
      hot.updateSettings({
        readOnly: true,
        contextMenu: false,
        disableVisualSelection: true,
        manualColumnResize: false,
        manualRowResize: false,
        comments: false
      })
      submitData ()
    }
  })
})

$('#import-csv').click(function () {
  $('#csv-file').click()
})

$('#add-rows').click(function () {
  var rowsToAdd = Number.parseInt(document.getElementById('add-rows-count').value)
  for (var i = 0; i < rowsToAdd; i++) {
    hot.alter('insert_row')
  }
})

var reader = new FileReader()
document.getElementById('csv-file').addEventListener('change', function (e) {
  reader.readAsText(e.target.files[0])
})
reader.onload = function (e) {
  Papa.parse(e.target.result, {
    complete: function (results) {
      for (var i = 0; i < results.data.length; i++) {
        var row = results.data[i]
        if (!row[0].trim().match(/^\d{1,2}\/\d{1,2}\/\d{2,4}$/)) {
          continue
        }

        hot.alter('insert_row')
        hot.populateFromArray(hot.countRows() - 1, 0, [row])
      }
    }
  })
}

var amountChange = function (rowNumber, prop, oldValue, newValue) {
  if (prop == 'amount') {
    if (!isNaN(newValue))
      totalAmount += newValue * 1.0
    if (!isNaN(oldValue))
      totalAmount -= oldValue * 1.0
    $('#sales-receipts-sum').html(totalAmount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1,'))
  }
}

var customerChange = function (rowNumber, prop, oldValue, newValue) {
  $('#customer-name').val(newValue)
  $('#customer-address-1').val('')
  $('#customer-address-2').val('')
  $('#customer-city').val('')
  $('#customer-state').val('')
  $('#customer-zip').val('')
  $('#customer-email').val('')

  $('#new-customer-modal').modal('show')
}

$('#new-customer-form').submit(function (e) {
  e.preventDefault()
  
  $('.spin').css('display', 'flex')
  $.post({
    url: '/api/companies',
    data: JSON.stringify({
      realmId: $('#company').val(),
      newCustomer: {
        'DisplayName': $('#customer-name').val(),
        'BillAddr': {
          'Line1': $('#customer-address-1').val(),
          'Line2': $('#customer-address-2').val(),
          'City': $('#customer-city').val(),
          'CountrySubDivisionCode': $('#customer-state').val(),
          'PostalCode': $('#customer-zip').val()
        },
        'PrimaryEmailAddr': {
          'Address': $('#customer-email').val()
        }
      },
      salesReceipts: hot.getSourceData()
    }),
    dataType: 'json',
    contentType: 'application/json; charset=utf-8',
  }).done(function (res) {
    if (res.ok) {
      customerNames = mapQbList(res.saveData.customers, 'DisplayName')
      customerNames.push(res.saveData.newCustomer.DisplayName)
      let settings = hot.getSettings()
      let columnCount = settings.columns.length
      for (let i = 0; i < columnCount; i++) {
        if (settings.columns[i].data === 'customer') {
          settings.columns[i].source = customerNames
          i = columnCount
        }
      }
      
      hot.updateSettings (settings)
      hot.validateCells()
      $('#new-customer-modal').modal('hide')
    } else {
      alert ('Company creation failed')
    }
  }).fail(function (err) {
    alert ('Something went wrong, try again later')
  }).always(function () {
    $('.spin').hide()
  })
})

var checkCustomerExists = function (rowNumber, prop, oldValue, newValue) {
  return customerNames.indexOf(newValue) !== -1
}

var hotHookCallbacks = {
  'afterChange': {
    'amount': {
      function: amountChange,
      restrictions: []
    },
    'customer': {
      function: customerChange,
      restrictions: [checkCustomerExists]
    }
  }
}
